export default "__VITE_ASSET__DvTpY56Y__"